import React from 'react';
import { View } from 'react-native';
import FormTextInput from '../../../../components/FormTextInput';
import BallotItemsListListControl from './BallotItemsListControl';
import DatePicker from './DatePicker';
import SliderControl from './SliderControl';
import MainButton from '../../../../components/Buttons/MainButton';
import { MainColors } from '../../../../constants/Colors';

const BallotForm = (props) => {
    return (
        <View>
            <FormTextInput
                label="Ballot Title"
                placeholder="Enter ballot title"
                accessibilityLabel="Enter ballot title"
                accessibilityHint="Type in a ballot title here"
                value={props.titleValue}
                onChangeText={props.onChangeTitleText}
                editable={props.titleEditable}
            />

            <FormTextInput
                label="Ballot Description (optional)"
                placeholder="Enter ballot description"
                accessibilityLabel="Enter ballot description"
                accessibilityHint="Type in a ballot description here"
                value={props.descriptionValue}
                onChangeText={props.onChangeDescriptionText}
                editable={props.descriptionEditable}
                multiline={true}
            />

            <DatePicker
                label="Start Date"
                value={props.startDateValue}
                onChangeText={props.onChangeStartDateText}
                disabled={props.startDateDisabled}
            />

            <DatePicker
                label="End Date"
                value={props.endDateValue}
                onChangeText={props.onChangeEndDateText}
                disabled={props.endDateDisabled}
            />

            <BallotItemsListListControl
                onNextButtonPress={props.onBallotItemNextButtonPress}
                listData={props.ballotItemsListData}
                onEditItemPressed={props.onEditBallotItemPressed}
                addBallotItemButtonDisabled={props.addBallotItemButtonDisabled}
                noBallotItemsMessage={props.noBallotItemsMessage}
            />

            <SliderControl
                headerLabel="Minimum Votes to be Valid"
                valueLabel={props.turnoutValueLabel}
                value={props.turnoutValue}
                onValueChange={props.onChangeTurnoutValue}
                disabled={props.turnoutSliderDisabled}
            />

            <SliderControl
                headerLabel="Majority Required to Win"
                valueLabel={props.majorityValueLabel}
                value={props.majorityValue}
                onValueChange={props.onChangeMajorityValue}
                disabled={props.majoritySliderDisabled}
            />

            <MainButton
                style={{ marginTop: 30, backgroundColor: props.formButtonDisabled ? MainColors.lightGray : MainColors.primary }}
                text={props.formButtonText}
                accessibilityLabel={props.formButtonAccessibilityLabel}
                accessibilityHint={props.formButtonAccessibilityHint}
                disabled={props.formButtonDisabled}
                onPress={props.formButtonPressed}
            />

        </View>
    )
}

export default BallotForm;